import { fetchPeriodEventData, fetchBestWorstStudents } from "./asyncThunks";

export const fetchPeriodEventDataBuilder = (builder) => {
  builder.addCase(fetchPeriodEventData.fulfilled, (state, action) => {
    state.periodEventData.data = action.payload;
  });
};

export const fetchBestWorstStudentsBuilder = (builder) => {
  builder.addCase(fetchBestWorstStudents.fulfilled, (state, action) => {
    state.bestStudent.data = action.payload.data.bestStudent;
    state.worstStudent.data = action.payload.data.worstStudent;
  });
};
